import { Emr } from '../../types';
import { v2Api } from '../v2Api';

export type EmrQuery = {
  projectId: number;
  emrId: number;
  name: string;
  description: string;
  metadata: Record<string, unknown>;
};

const tags = ['emr'] as const;

const emrApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      createEmr: builder.mutation<{ data: Emr }, Omit<EmrQuery, 'emrId'>>({
        query: ({ projectId, ...body }) => ({
          url: `projects/${projectId}/emrs`,
          method: 'POST',
          body,
        }),
        invalidatesTags: tags,
      }),
      editEmr: builder.mutation<Emr, EmrQuery>({
        query: ({ projectId, emrId, ...body }) => ({
          url: `projects/${projectId}/emrs/${emrId}`,
          method: 'PATCH',
          body,
        }),
        invalidatesTags: tags,
      }),
      deleteEmr: builder.mutation<Emr, { projectId: number; emrId: number }>({
        query: ({ projectId, emrId }) => ({
          url: `projects/${projectId}/emrs/${emrId}`,
          method: 'DELETE',
        }),
        invalidatesTags: tags,
      }),
      getEmrs: builder.query<Emr, { projectId: number }>({
        query: ({ projectId }) => `projects/${projectId}/emrs`,
        providesTags: tags,
        transformResponse: (response: { data: Emr[] }) => response.data[0],
      }),
    }),
  });

export default emrApi;
